<template>
    <div>
        <n-bread
                v-bind:content="{bread_list, bread_active}"
        ></n-bread>
        <n-delete
                @closeModal="closeModal"
                @deleteResource="deleteAuction"
        ></n-delete>

      <n-delete-zone-auction
        @closeModal="closeModal"
        @deleteResourceZoneAuction="deleteZoneAuction">
        </n-delete-zone-auction>
        <n-modal-auction
                v-if="formData"
                v-bind:content="{formData: formData, myError: myError, regionData:regionListData,
                cityData: cityData,
                }"
                @closeModal="closeModal"
                @refreshPage="refreshPage"
        ></n-modal-auction>

<!--      <div class="border border-blue-900   py-3 px-4 rounded-top rounded-bottom" style="background-color: #bde2ef;margin-bottom:10px;">-->
<!--        <p class="" style="font-size: 15px">-->
<!--          Poichè il sito pvp.giustizia.it è stato completamente rinnovato, i link degli immobili in asta presenti nell'archivio <strong>non sono più attivi</strong>.-->
<!--          <br>-->

<!--        </p>-->

<!--      </div>-->

        <div class="row">
            <div class="col-lg-3">

                <select class="form-control" id="exampleFormControlSelect1"
                        style="font-size:120%;font-weight:bold;"
                        v-model="selectedZone">
                    <option

                            v-for="(r, index) in regionList"
                            :value="{region:r.regione}"
                    >{{CHANGE_REGION_NAME(r.regione)}} ({{r.tot}})
                    </option>
                </select>


            </div>

            <div class="col-lg-9">
              <div class="row">
                <div class="col-lg-2" v-for="(c, index) in cityList">
                  <div class="abtg-zones">
                    <div class="abtg-singlezone"
                         :class="isThisLinkActive({type:'city', city: c.my_city.comune})"
                    >
                      <a href="#"
                         style="font-size:85%"
                         @click="auctionListByCity({cityId:c.my_city.id, city: c.my_city.comune})"
                      >{{(c.my_city.comune)}}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>


        </div>
        <hr>


        <!-- auction list -->

        <div class="row">
            <div class="col-md-12">
                <div class="card abtg__default-card abtg__default-card-border">
                    <div class="card-head">

                        <header>{{CHANGE_REGION_NAME(regionName)}} | {{cityName}}
                        </header>
                        <div class="abtg__header_popover">
                            <popover module="auction" content="list" position="right"></popover>
                        </div>
                        <div class="tools">

                            <router-link :to="{'name' : 'N_AuctionMap'}"
v-if="CHECK_ROLE_SIDEBAR(200)"
                                         class="btn btn-default shadow-none abtg__btn-tool abtg__btn-star text-right">
                                Importa Aste
                            </router-link>

                            <a href="#" @click="newAuction()"
                               class="btn btn-default shadow-none abtg__btn-tool abtg__btn-star text-right"
                            >
                                Carica immobile in asta
                            </a>

                        </div>
                    </div>


                    <div class="card-body ">

                        <ul class="nav nav-tabs">
                            <li class="nav-item abtg__item">
                                <a
                                        :class="isThisTabActive({color:null})"

                                        @click="activeColor = null">

                                    <div class="abtg__circle all"></div>
                                </a>
                            </li>
                            <li class="nav-item abtg__item"><a
                                    :class="isThisTabActive({color:4})"
                                    @click="activeColor = 4">
                                <div class="abtg__circle green"></div>
                            </a>
                            </li>
                            <li class="nav-item abtg__item"><a
                                    :class="isThisTabActive({color:1})"
                                    @click="activeColor = 1">
                                <div class="abtg__circle red"></div>
                            </a>
                            </li>
                            <li class="nav-item abtg__item"><a
                                    :class="isThisTabActive({color:2})"
                                    @click="activeColor = 2">
                                <div class="abtg__circle yellow"></div>
                            </a>
                            </li>

                            <li class="nav-item abtg__item"><a
                                    :class="isThisTabActive({color:3})"
                                    @click="activeColor = 3">
                                <div class="abtg__circle grey"></div>
                            </a>
                            </li>
                            <li class="nav-item abtg__item"><a
                                    :class="blankActive"

                                    @click="activeColor = 0">
                                <img src="/img/auction-color.png">
                            </a>
                            </li>

                        </ul>


                        <div class="table-responsive">

                            <table class="mdl-data-table ml-table-striped ml-table-bordered mdl-js-data-table   is-upgraded">
                                <thead>
                                <tr>


                                    <th class="mdl-data-table__cell--non-numeric text-left">
                                        <span class="abtg__text-abtg">{{$t('auction.table_archive_label_address')}}</span>
                                    </th>

                                    <th class="mdl-data-table__cell--non-numeric text-left">
                                        <span class="abtg__text-abtg">Data Vendita</span>
                                        <i class="fas fa-sort-amount-up"
                                           @click="handlingSort('date')"
                                           v-show="sortDate === false"></i>
                                        <i class="fas fa-sort-amount-down"
                                           @click="handlingSort('date')"
                                           v-show="sortDate === true"></i>
                                    </th>
                                    <th class="mdl-data-table__cell--non-numeric text-left">
                                        <span class="abtg__text-abtg">{{$t('auction.table_archive_label_auction_base')}}</span>

                                        <i class="fas fa-sort-amount-up"
                                           @click="handlingSort('baseAuction')"
                                           v-show="sortBaseAuction === false"></i>
                                        <i class="fas fa-sort-amount-down"
                                           @click="handlingSort('baseAuction')"
                                           v-show="sortBaseAuction === true"></i>
                                    </th>
                                    <th class="mdl-data-table__cell--non-numeric text-left">
                                        <span class="abtg__text-abtg">{{$t('auction.table_archive_label_minimum_offer')}}</span>
                                    </th>
                                    <th class="mdl-data-table__cell--non-numeric text-left">
                                        <span class="abtg__text-abtg">Rialzo min.</span>
                                    </th>
                                    <th class="mdl-data-table__cell--non-numeric text-left">
                                        <span class="abtg__text-abtg">Mq (€/mq)</span>
                                    </th>
                                    <th class="mdl-data-table__cell--non-numeric text-left">
                                        <span class="abtg__text-abtg">{{$t('auction.table_archive_label_street_price')}}</span>
                                    </th>
                                    <th class="mdl-data-table__cell--non-numeric text-left">
                                        <span class="abtg__text-abtg">Scost.</span>
                                    </th>
                                    <th class="mdl-data-table__cell--non-numeric text-left" style="color:red">
                                    <a href="#" style="color:red" @click="setIdZoneToDelete(myCityIdSelected)">  <i class="fas fa-trash  " style="color: red"></i> {{cityName}}</a>
                                    </th>

                                </tr>
                                </thead>
                                <tbody>

                                <tr v-for="m in auctionList">

                                    <td class="align-top">

                                        <div class="btn-group" role="group">
                                            <button id="btnGroupDrop3" type="button"
                                                    style="margin-top:-3px;background-color:transparent !important;border:none !important;padding:0 !important;margin:0 0 5px 0 !important;"
                                                    class="btn btn-default shadow-none abtg__btn-tool dropdown-toggle"
                                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                &nbsp;
                                                <div class="abtg__circle" :class="AUCTION_COLOR(m.color)"></div>
                                            </button>
                                            <div class="dropdown-menu" aria-labelledby="btnGroupDrop3"
                                                 style="padding-bottom:20px;">
                                                <a
                                                        class="dropdown-item"
                                                        style="margin-bottom:-20px !important;"
                                                        @click="changeColor({data:m, color:4})">
                                                    <i class="fas fa-circle" style="color:green"></i>&nbsp;
                                                </a>&nbsp;&nbsp;
                                                <a
                                                        class="dropdown-item"
                                                        style="margin-bottom:-20px !important;"
                                                        @click="changeColor({data:m, color:1})">
                                                    <i class="fas fa-circle" style="color:red"></i>&nbsp;
                                                </a>&nbsp;&nbsp;
                                                <a
                                                        class="dropdown-item"
                                                        data-toggle="modal" data-target="#modalSingleMapping"
                                                        style="margin-bottom:-20px !important;"
                                                        @click="changeColor({data:m, color:3})">
                                                    <i class="fas fa-circle" style="color:grey"></i>&nbsp;
                                                </a>
                                                &nbsp;&nbsp;<a
                                                    class="dropdown-item"
                                                    data-toggle="modal" data-target="#modalSingleMapping"
                                                    style="margin-bottom:-20px !important;"
                                                    @click="changeColor({data:m, color:2})">
                                                <i class="fas fa-circle" style="color:yellow"></i>&nbsp;
                                            </a>
                                            </div>
                                        </div>

                                        {{m.city}}<br>
                                        <em v-if="m.indirizzo">{{WORD_CUT(m.indirizzo,20)}}</em><br>
                                        <a :href="m.link" target="_blank">Link dettaglio asta</a>

                                    </td>
                                    <td class="align-top">
                                        {{m.data_asta}}
                                    </td>
                                    <td class="align-top">
                                        {{FORMAT_PRICE(m.base_asta) }}
                                    </td>
                                    <td class="mdl-data-table__cell--non-numeric align-top">
                                        {{FORMAT_PRICE(m.offerta_minima) }}
                                    </td>
                                    <td class="mdl-data-table__cell--non-numeric align-top">
                                        {{FORMAT_PRICE(m.rialzo_minimo) }}
                                    </td>
                                    <td class="mdl-data-table__cell--non-numeric align-top">
                                        {{m.mq}}<br><em>(€ {{mqPrice(m)}} al mq)</em>
                                    </td>
                                    <td class="align-top">
                                        € {{FORMAT_PRICE(m.street_price) }} al mq<br>
                                        [<a href="#" @click="settingZoneData(m)"
                                           v-if="CHECK_ROLE_SIDEBAR(200)"
                                        >Da nuova mappatura</a>] <br>
                                      [<a target="_blank" href="/mapping" >Da archivio mappatura</a>]<br>
                                      [<a href="#"  @click="editAuction(m)">Inserisci a mano</a>]
                                    </td>
                                    <td class="mdl-data-table__cell--non-numeric align-top">
                                        {{deviation(m)}}%
                                    </td>

                                    <td class="align-top">
                                        <div class="btn-group" role="group">
                                            <button id="btnGroupDrop1" type="button"
                                                    style="margin-top:-3px;"
                                                    class="btn btn-default shadow-none abtg__btn-tool dropdown-toggle"
                                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                &nbsp;<i class="fas fa-ellipsis-v"></i>&nbsp;
                                            </button>


                                            <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                                <a
                                                        class="dropdown-item"
                                                        style="margin-bottom:-15px !important;"
                                                        @click="editAuction(m)">
                                                    <i class="fas fa-list  "></i>&nbsp; Modifica
                                                </a>&nbsp;&nbsp;
                                                <a
                                                        class="dropdown-item"
                                                        style="margin-bottom:-15px !important;"
                                                        @click="createOperation({id: m.id})">
                                                    <i class="fas fa-calculator  "></i>&nbsp; Conto Economico
                                                </a>&nbsp;&nbsp;
                                                <a
                                                        class="dropdown-item"
                                                        data-toggle="modal" data-target="#modalSingleMapping"
                                                        style="margin-bottom:-15px !important;"
                                                        @click="setIdToDelete(m.id)">
                                                    <i class="far fa-trash-alt  "></i>&nbsp; Cancella
                                                </a>
                                                &nbsp;&nbsp;
                                            </div>


                                        </div>

                                        <div class="btn-group" role="group">
                                            <button id="btnGroupDrop2" type="button"
                                                    style="margin-top:-3px;"
                                                    class="btn btn-default shadow-none abtg__btn-tool dropdown-toggle"
                                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                &nbsp;<i class="far fa-circle"></i>&nbsp;
                                            </button>


                                            <div class="dropdown-menu" aria-labelledby="btnGroupDrop2"
                                                 style="padding-bottom:20px;">
                                                <a
                                                        class="dropdown-item"
                                                        style="margin-bottom:-20px !important;"
                                                        @click="changeColor({data:m, color:4})">
                                                    <i class="fas fa-circle" style="color:green"></i>&nbsp;
                                                </a>&nbsp;&nbsp;
                                                <a
                                                        class="dropdown-item"
                                                        style="margin-bottom:-20px !important;"
                                                        @click="changeColor({data:m, color:1})">
                                                    <i class="fas fa-circle" style="color:red"></i>&nbsp;
                                                </a>&nbsp;&nbsp;
                                                <a
                                                        class="dropdown-item"
                                                        data-toggle="modal" data-target="#modalSingleMapping"
                                                        style="margin-bottom:-20px !important;"
                                                        @click="changeColor({data:m, color:3})">
                                                    <i class="fas fa-circle" style="color:grey"></i>&nbsp;
                                                </a>
                                                &nbsp;&nbsp;<a
                                                    class="dropdown-item"
                                                    data-toggle="modal" data-target="#modalSingleMapping"
                                                    style="margin-bottom:-20px !important;"
                                                    @click="changeColor({data:m, color:2})">
                                                <i class="fas fa-circle" style="color:yellow"></i>&nbsp;
                                            </a>
                                            </div>


                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>


                    </div>
                </div>


            </div>
        </div>


        <!-- end auction list -->
    </div>
</template>

<script>
    import NBread from '@/partials/bread';
    import {mapActions, mapState, mapMutations} from 'vuex';
    import {mixin} from '@/helpers/helper';
    import {roles} from '@/helpers/roles';
    import Popover from '@/partials/popover';
    import NModalAuction from '@/partials/auction/modal_auction';
    import NDelete from '@/partials/modal_delete';
    import NDeleteZoneAuction from '@/partials/modal_delete_zone_auction';

    export default {
        mixins: [mixin, roles],
        data() {
            return {
                activeColor: null,
                sortBaseAuction: false,
                sortDate: false,
                priorityDate: false,
                priorityBaseAuction: false,
                filteredData: null,
                selectedZone: {},

            }
        },
        created() {
          this.trackActivity();
            this.SET_DATA({name: 'bread_active', data: {label: 'Aste'}});
            this.regionListUsed();
            this.lastAuction();
            setTimeout(() => {
                this.selectedZone = {"region": this.regionName};
            }, 1000)
        },
        watch: {
            zoneSavedData(oldValue, newValue) {
                if ((oldValue) !== (newValue)) {
                    this.$router.push({path: '/mapping/search/' + this.zoneSavedData.zoneId + '/' + this.zoneSavedData.region});
                }
            },
            selectedZone(value) {
                this.cityListUsed(value);
            }
        },
        components: {
            NBread, Popover, NModalAuction, NDelete, NDeleteZoneAuction
        },
        computed: {
            ...mapState('n_auction', [
                'bread_active', 'bread_list',
                'regionList', 'cityList', 'auctionListByCityData',
                'regionName', 'cityName', 'formData', 'myError',
                'regionListData', 'cityData', 'idToDelete','idZoneToDelete', 'myCityIdSelected'
            ]),

            ...mapState('n_mapping', ['zoneSaved', 'zoneSavedData']),

            blankActive() {
                if (this.activeColor === 0) {
                    return 'active';
                }
            },



            auctionList() {
                this.filteredData = this.auctionListByCityData;
                if (this.auctionListByCityData && this.activeColor != null) {

                    this.filteredData = this.auctionListByCityData.filter(q => {
                        if (this.activeColor) {
                            return parseInt(q.color) === this.activeColor;
                        } else {
                            return parseInt(q.color) > 0;
                        }

                    })
                } else {

                    if (this.filteredData) {
                        this.filteredData = this.auctionListByCityData.sort((a, b) => {
                            return a.color - b.color;
                        });
                    }
                }

                if (this.filteredData) {

                    return this.filteredData.sort((a, b) => {
                        if (this.priorityBaseAuction === true) {
                            return this.sortBaseAuction === true ? b.base_asta - a.base_asta : a.base_asta - b.base_asta;
                        }
                        if (this.priorityDate === true) {
                            return this.sortDate === true ? new Date(b.data_asta_pura) - new Date(a.data_asta_pura) : new Date(a.data_asta_pura) - new Date(b.data_asta_pura);
                        }
                    })
                }

            }
        },
        methods: {
            ...mapActions('n_auction', ['regionListUsed', 'cityListUsed', 'auctionListByCity',
                'lastAuction', 'cityListByRegion', 'createOperation',
                'deleteAuction', 'changeColor', 'deleteZoneAuction'
            ]),
            ...mapActions('n_mapping', ['sendZoneData']),
            ...mapMutations('n_auction', ['SET_DATA']),

          trackActivity()
          {
            axios.get('/api/v2/trackactivity/track')
                .then(() => {

                })
          },
            refreshPage(force)
            {
              if(force)
              {
                  window.location.href = '/auction';
              }
            },
            mqPrice(data, mode) {
                if (data.offerta_minima > 0 && data.mq > 0) {
                    let v = data.offerta_minima / data.mq;
                    if(mode === 'pure')
                    {
                        return v;
                    }
                    return this.FORMAT_PRICE(Math.round(v));
                }
            },


            deviation(data) {
                let value = (this.mqPrice(data, 'pure') - data.street_price) / this.mqPrice(data, 'pure') * 100;
                return  Math.round(value);
            },
            editAuction(data) {
                this.cityListByRegion({region: data.regione});
                this.SET_DATA({name: 'formData', data: {...data}});
                this.showModal('m-auction');
            },

            newAuction(){
                this.cityListByRegion({region: ''});
                this.SET_DATA({name: 'formData', data: {}})
                this.showModal('m-auction');
            },
            showModal(modalName) {
                this.$modal.show(modalName);
            },

            closeModal(modalName) {
                this.$modal.hide(modalName);

            },
            isThisLinkActive(payload) {
                switch (payload.type) {
                    case 'region':
                        if (this.regionName && this.regionName == payload.region) {
                            return 'abtg-city-active';
                        }
                        break;

                    case 'city':
                        if (this.cityName && this.cityName == payload.city) {
                            return 'abtg-zone-active';
                        }
                        break;
                }

            },

            isThisTabActive(payload) {
                if (this.activeColor && parseInt(this.activeColor) == parseInt(payload.color)) {
                    return 'active';
                }
            },

            setIdToDelete(id) {
                this.SET_DATA({name: 'idToDelete', data: id});
                this.showModal('m-delete');
            },

          setIdZoneToDelete(id) {
            this.SET_DATA({name: 'idZoneToDelete', data: id});
            this.showModal('m-delete-zone-auction');
          },

            handlingSort(sortBy) {
                switch (sortBy) {
                    case 'baseAuction':
                        this.priorityBaseAuction = true;
                        this.sortBaseAuction = !this.sortBaseAuction;
                        this.priorityDate = false;
                        this.sortDate = false;
                        break;
                    case 'date':
                        this.priorityDate = true;
                        this.sortDate = !this.sortDate;
                        this.priorityBaseAuction = false;
                        this.sortBaseAuction = false;
                        break;
                }
            },

            settingZoneData(payload) {
                this.sendZoneData({
                    zone: payload.indirizzo,
                    macrozone: '-',
                    microzone: '-',
                    city_id: payload.city_id,
                    region: payload.regione,
                    searchType: 'mapping',
                    auctionId: payload.id,
                    mq: payload.mq
                });
            },


        }
    }
</script>
